const deviceInfo = window.__DEVICE__;

export const Device = {
    model: deviceInfo?.model || "",
    os: deviceInfo?.os || "",
    isDarkMode: deviceInfo?.isDarkMode || false,
    language: deviceInfo?.language || "ko",
    inset: {
        statusBarHeight: deviceInfo?.inset?.statusBarHeight || 0,
        navigationBarHeight: deviceInfo?.inset?.navigationBarHeight || 0
    }
}